import { render, staticRenderFns } from "./QuestionHistoryForm.vue?vue&type=template&id=3b506980&"
import script from "./QuestionHistoryForm.vue?vue&type=script&lang=js&"
export * from "./QuestionHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports